<script>
import axios from 'axios'

export default {
name: 'StoreDetailsScript',

mounted() {
    window.preferred = function(url) {
        axios.post(url, data).catch();
    }
    window.displayPreferredRetailer = function() {
        document.getElementById('pref-retailer-display').closest('li').style.display = "block";
        document.getElementById('pref-retailer-cta').style.display = "none";
        document.querySelector('#pref-retailer-cta a .material-icons').innerHTML = "check";
    }
  },
};
</script>